import React from "react";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import "./RimanBanner.scss";

const highlights = [
  {
    kicker: "$440B+",
    title: "Beauty Market",
    text: "The global beauty industry exceeds $440 billion annually.",
  },
  {
    kicker: "Fast Growth",
    title: "Skincare Demand",
    text: "Skincare continues to be one of the fastest-growing beauty categories.",
  },
  {
    kicker: "Global Appeal",
    title: "K-Beauty Innovation",
    text: "Korean skincare innovation is gaining worldwide recognition.",
  },
  {
    kicker: "Digital Reach",
    title: "Social Momentum",
    text: "Social media has made beauty trends spread faster than ever.",
  },
];

export default function RimanBanner() {
  return (
    <Box className="riman-opportunity-banner">
      <Container maxWidth="xl">
        <Box className="riman-opportunity-banner__inner">
          <Typography variant="h2" className="banner-title">
            The Rise of K-Beauty
          </Typography>

          <Typography variant="h5" className="banner-subtitle">
            A Global Industry Creating New Opportunities for Entrepreneurs
          </Typography>

          <Typography variant="body1" className="banner-intro">
            Today, many professionals are looking for flexible business
            opportunities that allow them to build income without leaving their
            careers.
          </Typography>

          <Typography variant="body1" className="banner-intro">
            Entrepreneurs know that success rarely comes from working harder alone.
            It often comes from positioning yourself in the right industry at the right time.
          </Typography>

          <Typography variant="body1" className="banner-intro">
            Right now, the global beauty industry is worth hundreds of billions of dollars, and skincare is its fastest-growing segment. Within that segment, Korean skincare is leading innovation worldwide.
          </Typography>

          <Typography variant="body1" className="banner-intro">
            Brands that represent this movement are gaining attention not only from consumers, but also from entrepreneurs who want to participate in the growth of this industry.
<br />Riman sits at the intersection of these trends.
          </Typography>

          <Grid container spacing={3} className="banner-grid">
            {highlights.map((item, index) => (
              <Grid item xs={12} sm={6} lg={3} key={index}>
                <Paper className="opportunity-card" elevation={0}>
                  <Typography className="opportunity-card__kicker">
                    {item.kicker}
                  </Typography>

                  <Typography variant="h6" className="opportunity-card__title">
                    {item.title}
                  </Typography>

                  <Typography variant="body2" className="opportunity-card__text">
                    {item.text}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

          <Box className="banner-footer-note">
            <Typography variant="body1">
              This combination of market demand, innovation, and digital
              connectivity makes the beauty industry attractive for people
              exploring new business models.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}